import { Text } from '@chakra-ui/react';

export const NoTicketsMessage: React.FC = () => {
  return <Text>Registration is not available. Please check back later.</Text>;
};
